import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Books from "@/pages/Books";
import Insights from "@/pages/Insights";
import ArticleDetail from "@/pages/ArticleDetail";
import Speaking from "@/pages/Speaking";
import ReformIntelligence from "@/pages/ReformIntelligence";
import Valor from "@/pages/Valor";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main className="min-h-screen">{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="*" element={
          <PublicLayout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/books" element={<Books />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:id" element={<ArticleDetail />} />
              <Route path="/speaking" element={<Speaking />} />
              <Route path="/reform-intelligence" element={<ReformIntelligence />} />
              <Route path="/valor" element={<Valor />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </PublicLayout>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
